import {Container} from 'constants/SampleConstants';
import {ManagedModelType} from 'models/ManagedModelDefinitions';
import {modelInaccessible, modelKeysToInaccessibleInfoByKey} from 'models/ManagedModelsReduxActions';
import {ModelManager} from 'models/managers/ModelManager';
import {getStore} from 'redux-stores/Store';
import * as StorableActions from 'samples/StorableActions';
import StorableStore from 'samples/StorableStore';

export class ContainerModelManager extends ModelManager<ManagedModelType.CONTAINER> {
  constructor() {
    super(ManagedModelType.CONTAINER);
  }

  async doFetchMulti(containerIds: Array<string>): Promise<void> {
    // The second param here says: we want data for all containers we have access to. Without it,
    // the entire call will throw an error if any containers are inaccessible.
    await StorableActions.bulkFetchContainers(containerIds, true);

    // Deleted containers and containers that we have insufficient privilege to see are simply not included
    const inaccessibleContainerIds = containerIds.filter((id) => !StorableStore.getContainer(id));
    if (inaccessibleContainerIds.length > 0) {
      getStore().dispatch(
        modelInaccessible(
          ManagedModelType.CONTAINER,
          modelKeysToInaccessibleInfoByKey(inaccessibleContainerIds)
        )
      );
    }
  }

  getModel(modelKey: string): Container | null {
    return StorableStore.getContainer(modelKey) || null;
  }
}
